import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `ComboCausaEliminacion`, method: 'GET', body: null, token: token})
}
